import { NotificationTypes } from '@chegg-ui/notification-banner';
import { createSlice } from '@reduxjs/toolkit';
export var errorModalState = {
  errorType: '',
  toast: {
    toastType: NotificationTypes.Information,
    toastMessage: undefined,
    toastTitle: undefined,
    isToastOpen: false,
    ctaText: undefined,
    ctaArg: undefined
  }
};
export var errorModalSlice = createSlice({
  initialState: errorModalState,
  name: 'error',
  reducers: {
    setErrorType: function setErrorType(state, action) {
      state.errorType = action.payload;
    },
    setIsToastOpen: function setIsToastOpen(state, _ref) {
      var payload = _ref.payload;
      var isOpen = payload.isOpen,
        title = payload.title,
        message = payload.message,
        type = payload.type,
        ctaText = payload.ctaText,
        ctaArg = payload.ctaArg;
      if (isOpen) {
        state.toast = {
          isToastOpen: true,
          toastTitle: title !== null && title !== void 0 ? title : '',
          toastMessage: message !== null && message !== void 0 ? message : '',
          toastType: type !== null && type !== void 0 ? type : NotificationTypes.Error,
          ctaText: ctaText,
          ctaArg: ctaArg
        };
      } else {
        state.toast = {
          isToastOpen: false,
          toastTitle: undefined,
          toastMessage: undefined,
          ctaText: undefined,
          toastType: NotificationTypes.Error,
          ctaArg: undefined
        };
      }
    }
  }
});
var _errorModalSlice$acti = errorModalSlice.actions,
  setErrorType = _errorModalSlice$acti.setErrorType,
  setIsToastOpen = _errorModalSlice$acti.setIsToastOpen;
export { setErrorType, setIsToastOpen };